export const resolveName = ({ familyName, givenName, displayName }) => ((!familyName && !givenName)
    ? displayName
    : [givenName, familyName].filter(name => !!name).join(' '));
